import moment from 'moment'

/**
 * 改行文字をbrに置換する関数
 * @param text - テキストデータ
 */
export const nl2br = (text: string) => {
  const regex = /(\n)/g
  return text.replace(regex, '<br>')
}

/**
 * URLを含む文字列のURLをリンクに置換
 * @param text - テキストデータ
 */
export const autoLink = (text: string, target?: string): string => {
  const t: string = target ? " target='" + target + "'" : ''
  return text.replace(/(http(s)?:\/\/[\x21-\x7e]+)/gi, "<a href='$1'" + t + '>$1</a>')
}

/**
 * Dateのフォーマットを'YYYY年MM月DD日'へ整形する
 * @param date - date
 */
export const adjustDateToJp = (date: string): string => {
  return moment(date).format('YYYY年MM月DD日')
}

/**
 * Dateのフォーマットを'YYYY年MM月DD日 HH:mm'へ整形する
 * @param date - date
 */
export const adjustDateTimeToJp = (date: string): string => {
  return moment(date).format('YYYY年MM月DD日 HH:mm')
}

/**
 * エンコードされたスタンプIDをUUID文字列に変換します
 * @param s - BASE64_RAWURLENCODE( [16]BYTES( UUID ) )でフォーマットされたスタンプID
 */
export const decodeStampUUID = (s: string): string => {
  const v: string[] = atob(s.replace(/_/g, '/').replace(/-/g, '+'))
    .split('')
    .map(c =>
      c
        .charCodeAt(0)
        .toString(16)
        .padStart(2, '0')
    )
  return [v.slice(0, 4).join(''), v.slice(4, 6).join(''), v.slice(6, 8).join(''), v.slice(8, 10).join(''), v.slice(10, 16).join('')].join('-')
}
